<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import Icon from 'dashboard/components-next/icon/Icon.vue';

const search = defineModel({ type: String, default: '' });
</script>

<template>
  <label>
    <Icon icon="i-lucide-search" class="size-4 shrink-0" />
    <input
      v-model="search"
      type="search"
      class="reset-base min-w-0 w-full text-sm leading-5 text-[#444c56] !m-0 !h-full !min-h-0 !appearance-none !rounded-none !border-0 !bg-transparent !p-0 ![outline:none] ![box-shadow:none]"
      placeholder="Buscar nome, telefone ou e-mail"
      aria-label="Buscar nome, telefone ou e-mail"
    />
  </label>
</template>
